import request from "../../utils/request";

const API_ROUTE = `${process.env.REACT_APP_BASE_API}api/v1`;

export async function healthCheckApi() {
    return request(`${API_ROUTE}/health-check`, {
        method: "GET",
    });
}
